import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";

const EnvConfig = Loadable(
	lazy(() =>
		import("./EnvConfigList").then(({ EnvConfigList }) => ({
			default: EnvConfigList,
		}))
	)
);

export const envConfigRoutes = [
	{
		path: "/manage-env",
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.ENV]}
			>
				<EnvConfig />
			</AuthorizedRoute>
		),
	},
];
